$(function() {

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  var active = false;

  var disabledDates = [];
  var disabledStart = [];
  var disabledEnd = [];
  var disabledFridays = [];
  var popupCheckedBothDates = false;
  var modalStep3 = $('form[name="modal-step-3"]').parsley();

  function openFacebookPopup(){
    $(".pop-up-facebook").toggleClass("active");

    createCookie('popupOpen', 'cookieOpen', 7);
  }

  $('#reservationSendBtn').on('click', function() {
    var that = $(this),
    og = that.html();

    modalStep3.validate();

    if (!modalStep3.isValid()) {
      return;
    }

    that.attr('disabled', 'disabled').css('opacity', '0.7').html(that.data('loading'));

    $.ajax({
      url: $('form[name="modal-step-3"]').attr('action'),
      type: $('form[name="modal-step-3"]').attr('method'),
      dataType: 'JSON',
      data: $('form[name="modal-step-3"]').serializeArray(),
    })
    .done(function(response) {
      if (response.success) {
        var myCookie = readCookie('popupOpen');

        openFacebookPopup();

        $('#reservationForm').slideUp();
        $('#reservationError').slideUp();
        $('#reservationSuccess').slideDown();

        gtag('event', 'conversion', {'send_to': 'AW-800545971/AlH_CKeP4YQBELO53f0C'});
        ga('send', {
          hitType: 'event',
          eventCategory: 'siteweb',
          eventAction: 'sent',
          eventLabel: 'sent-info-form',
          eventValue: 1
        });
      }
      else {
        $('#reservationSuccess').hide()
        $('#reservationError').show();
      }
    })
    .fail(function() {
      $('#reservationSuccess').hide()
      $('#reservationError').show();
    })
    .always(function() {
      that.removeAttr('disabled').css('opacity', '1').html(og);
    });
  });

  $.get(disabled_dates_url, function(data) {
    disabledDates = data.disabled;
    disabledFridays = data.fridays;

    $.each(disabledDates, function(a, b){
      if (b.end == false || (b.start && b.end)){
        disabledStart.push(b.dt);
      }
      if (b.start == false || (b.start && b.end)){
        disabledEnd.push(b.dt);
      }
    });

    $.each(disabledFridays, function(a, b){
      disabledEnd.push(b.dt);
    });

    datepicka();
  });

  function datepicka() {

    var current = moment().format('YYYY-MM-DD');

    var datepickerOptions = {
      language: "fr",
      startDate: current,
      format: "yyyy-mm-dd",
      maxViewMode: 1,
      todayHighlight: true,
      keyboardNavigation: false,
      datesDisabled: [],
      beforeShowDay: function (date){
        var test = moment(date).format('YYYY-MM-DD'),
        classes = 'disabled-date ';

        if (disabledDates[test] != undefined){
          if (disabledDates[test].start){
            classes += 'start ';
          }
          if (disabledDates[test].end){
            classes += 'end ';
          }
          if (disabledDates[test].exception != undefined){
            classes = ' exception';
          }

          return {
            classes: classes
          };
        }

        //checker pour voir si ya le vendredi disabled
        if (this.picker == 'end' && disabledFridays[test] != undefined && disabledFridays[test].exception != undefined) {
          return {
            classes: ' exception'
          };
        }
      },
    };

    var modal = document.querySelector('.modal');
    modal.style.position = 'initial';
    setTimeout(function() {
      modal.style.position = 'fixed';
    }, 50);

    datepickerOptions.picker = 'start';
    datepickerOptions.datesDisabled = disabledStart;

    $('#start_date').datepicker(datepickerOptions).on('changeDate', function(e){
      var end_date_value = moment($('#start_date').val()).add(2, 'days').format('YYYY-MM-DD');
      $('#start_date').datepicker('hide');
      $('#end_date').datepicker('show');
      $('#end_date').datepicker('update', end_date_value);
    });

    $('#resersearch-from').datepicker(datepickerOptions).on('changeDate', function(e) {
      $('#resersearch-from').datepicker('hide');
      var automaticToDate = moment($('#resersearch-from').val()).add(2, 'days');
      var formatedAutomaticToDate = automaticToDate.format('YYYY-MM-DD');

      if (disabledStart.indexOf(formatedAutomaticToDate) == -1 && disabledEnd.indexOf(formatedAutomaticToDate) == -1) {
        if (automaticToDate.weekday() == 5) {
          formatedAutomaticToDate = automaticToDate.add(1, 'day').format('YYYY-MM-DD');
        }

        $('#resersearch-to').datepicker('update', formatedAutomaticToDate);
      }
      else {
        $('#resersearch-to').datepicker('update', '');
      }

      $('#resersearch-to').datepicker('show');
    });

    datepickerOptions.picker = 'end';
    datepickerOptions.datesDisabled = disabledEnd;

    $('#end_date').datepicker(datepickerOptions).on('changeDate', function(e){
      $('#end_date').datepicker('hide');
    });

    $('#end_date').on('change', function(){
      $('#reservationSendBtn').css({'opacity': 0.5}).attr('disabled', 'disabled');
      $('.dates_validation').hide();
      dateMessage();
    });

    $('#resersearch-to').datepicker(datepickerOptions).on('changeDate', function(e) {
      $('#resersearch-to').datepicker('hide');

      $.get($('#resersearch-to').data('href'), {
        'from': $('#resersearch-from').val(),
        'to': $('#resersearch-to').val()
      }, function(data) {
        if (data.success) {
          $('#resersearch-from, #resersearch-to').removeClass('parsley-error');
          $('#side-reser-form .btn-reserved').removeAttr('disabled');

          updateSidePanel(data);
        }
        else {
          $('#resersearch-from, #resersearch-to').addClass('parsley-error');
          $('#side-reser-form .btn-reserved').attr('disabled', 'disabled');
        }
      });
    });

  }

  function updateSidePanel(data){

    var sidePaneRabaisTemplate = _.template($('#sidePaneRabais').html());
    var sidePanePriceTemplate = _.template($('#sidePanePrice').html());
    var sidePaneDisclaimerTemplate = _.template($('#sidePaneDisclaimer').html());

    //pas fonctionné
    if (!data.success) {
      return;
    }

    //rebates section
    $('#side-pane-rabais').empty().append(sidePaneRabaisTemplate({
      applicableRebatesCount: data.rebates.length,
      applicableRebates: data.rebates
    }));

    //price section
    var sidePanePriceString = sidePanePriceTemplate({
      specific: data.specific,
      specific_days: data.specific_days,
      applicableRebatesCount: data.rebates.length,
      applicableRebates: data.rebates,
      total: data.total,
      total_no_rebate: data.total_no_rebate,
      total_string: data.total_string,
      total_string_no_rebate: data.total_string_no_rebate
    });

    sidePanePriceString = sidePanePriceString.replace('<days>', data.specific_days);

    $('#side-pane-price').empty().append(sidePanePriceString);

    //disclaimer section
    $('#side-pane-disclaimer').empty().append(sidePaneDisclaimerTemplate({
      specific: data.specific
    }));
  }

  var dateMessageDatesSuccess = true;

  function dateMessage(){
    $('form[name="modal-step-3"]').find('input[name="start_date"]').val($('#start_date').val());
    $('form[name="modal-step-3"]').find('input[name="end_date"]').val($('#end_date').val());

    if ($('#start_date').val() != '' && $('#end_date').val() != ''){
      data = {
        ds : $('#start_date').val(),
        de : $('#end_date').val()
      };
      $.ajax({
        url : $('#start_date').data("url"),
        type: 'GET',
        dataType: 'json',
        data: data
      })
      .success(function(result){
        popupCheckedBothDates = true;
        dateMessageDatesSuccess = result.success;

        if(result.success){
          $('#reservationSendBtn').css({'opacity': 1}).removeAttr('disabled');
          $('#resersearch-from').attr('value', $('#start_date').val());
          $('#resersearch-to ').attr('value', $('#end_date').val());
          $(".calendar_trigger.start").html($('#start_date').val());
          $(".calendar_trigger.end").html($('#end_date').val());
          $('.dates_validation').css("display","inline-block");
          facebookTag('track', 'Lead', {content_type: 'demande-info'});
          $('.dates_validation .message').html('<span style="color: inherit; font-weight:inherit; cursor:pointer">' + result.message + '<br></span>');
          $(".pre-reservez-maintenant").css("display","inline-block");
          $(".other_date").css("display","none");
        }
        else{
          $('#reservationSendBtn').css({'opacity': 1}).removeAttr('disabled');
          $('.dates_validation .message').html(result.message+ '<br></span>');
          facebookTag('track', 'Lead', {content_type: 'demande-info'});
          gtag('event', 'prospect_demande_info', {
            'event_category':'demande-info-form',
            'event_action':'sent',
            'event_label':'demande-info-form-sent'
          });
          $(".pre-reservez-maintenant").css("display","none");
          $(".other_date").css("display","inline-block");
        }

        $('.dates_validation').show();
      })
      .fail(function(result){
        $('.dates_validation').hide();
        $('#reservationSendBtn').css({'opacity': 1}).removeAttr('disabled');
      });
    }
  }

  $(".other_date").on('click', function(){
    previous();
    lookPrevNext();
  });

  $(".pre-reservez-maintenant").on('click', function(){
    $(".pre-reservez-maintenant").hide();
    $(".reservez-maintenant").show();
    $('#modal-search-bedrooms').show();
    $('#modal-search-peoples').show();
    $('#modal-search-bedrooms').removeAttr('disabled');
    $('#modal-search-peoples').removeAttr('disabled');
  });

  $(".reservez-maintenant").on('click', function(){
    var that = $(this);
    var step2Parsley = $('form[name="modal-step-2"]').parsley();

    step2Parsley.validate();

    if (step2Parsley.isValid()) {
      that.attr('disabled', 'disabled').css('opacity', '0.6');

      $.ajax({
        url: $('form#side-reser-form').attr('action'),
        type: $('form#side-reser-form').attr('method'),
        dataType: 'json',
        data: {
          from: $('#start_date').val(),
          to: $('#end_date').val(),
          bedrooms: $('#modal-search-bedrooms').val(),
          persons: $('#modal-search-peoples').val()
        },
      })
      .done(function(data) {
        if (!data.success){
          $('#stepByStepInfo .step-2').find('.alert').remove();
          $('#stepByStepInfo .step-2').find('.alerts').append('<p class="alert alert-error">' + data.message + '</p>');
        }
        else{
          ga('send', {
            hitType: 'event',
            eventCategory: 'siteweb',
            eventAction: 'panier',
            eventLabel: 'panier-reservation',
            eventValue: 1
          });
          setTimeout(function(){
            window.location = data.redirect;
          }, 500)
        }
      })
      .fail(function(data) {
        $('#stepByStepInfo .step-2').find('.alert').remove();
        $('#stepByStepInfo .step-2').find('.alerts').append('<p class="alert alert-error">Impossible de réserver pour ces dates, une erreur est survenue</p>');
      })
      .always(function(){
        that.removeAttr('disabled').css('opacity', 1);
      });
    }

  });

  function closeMoreInfo_OpenReservation(){
    $('#infoModal .close').trigger('click');
    $('html, body').animate({
      scrollTop: $('#reser-form').offset().top
    }, 500);
    setTimeout(function(){
      $('#resersearch-from').datepicker('show');
    }, 500);
  }

  if(iOS == true){
    $('.ajax-date-btn').click(function(){
      $(".modal.fade.in").css("position","absolute");
      $("html, body").animate({ scrollTop: 68 }, "slow");
    });
    $("#reservedButton").click(function(){
      $(".reservedPopup").css("position","absolute");
      $(".reservedPopup").css("top","68px");
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  }

  if ($('.bxslider-cottage').length > 0) {
    $('.bxslider-cottage').bxSlider({
      controls: true,
      pager: false,
      auto: false,
      speed: 1300,
      pause: 5500
    });
  }

  $('.right-top-btn').on('click', function(){
    if ($('#infoModal').find('[name="start_date"]').val() != '' && $('#infoModal').find('[name="end_date"]').val() != '' && !popupCheckedBothDates) {
      dateMessage();
    }
  });

  // Focus the first input.
  $("#a").find("input").first().focus();

  //reservation portion ==================================================================
  var today = moment();//.add(1, 'days');
  var pikadayOptions = {
    firstDay: 1,
    i18n: i18n,
    keyboardInput: false
  };



  $('form#side-reser-form').on('submit', function(e){
    e.preventDefault();

    var that = $(this);

    $.ajax({
      url: that.attr('action'),
      type: that.attr('method'),
      dataType: 'json',
      data: that.serializeArray(),
    })
    .done(function(data) {
      if (!data.success){
        that.find('.alert').remove();
        that.prepend('<p class="alert alert-error">' + data.message + '</p>');

        // btnReservedOff();
      }
      else{
        //call le goal
        console.log('panier-reservation');
        ga('send', {
          hitType: 'event',
          eventCategory: 'siteweb',
          eventAction: 'panier',
          eventLabel: 'panier-reservation',
          eventValue: 1
        });
        setTimeout(function(){
          window.location = data.redirect;
        }, 500)
      }
    })
    .fail(function(data) {
      that.find('.alert').remove();
      that.prepend('<p class="alert alert-error">Impossible de réserver pour ces dates, une erreur est survenue</p>');
      // btnReservedOff();
    });
  });
  //end reservation portion ==============================================================

  var groups = {};
  $('.galleryItem').each(function() {
    var id = parseInt($(this).attr('data-group'), 10);
    if(!groups[id]) {
      groups[id] = [];
    }
    groups[id].push(this);
  });

  $.each(groups, function() {
    $(this).magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      gallery: {enabled: true},
      image: {
        titleSrc: function(item) {
          return item.el.attr('title');
        }
      }
    });
  });

  $('.tab-links').click(function() {
    var link = $(this);
    $('.tabs li').removeClass('active');
    link.parent().addClass('active');
    $('.div-tab').hide();
    $('#content-'+link.data('tab')).show();

    if (link.data('tab') == 'map') {
      if ($('#cottage-map iframe').length > 0) {
        $('#cottage-map iframe').attr('src', $('#cottage-map iframe').data('src'))
      }
    }

    if (link.data('tab') == 'gallery') {
      $('#content-gallery').find('img.unveil').trigger("unveil");
    }
  });

  $('.trigger-scroll-down').click(function() {
    $('a.review-link').trigger('click');
    $('html,body').animate({
      scrollTop: 800
    }, 1000, 'swing');
  });

  $('.rebate-trigger').click(function() {
    $('a.pricing-link').trigger('click');
    $('html,body').animate({
      scrollTop: 800
    }, 1000, 'swing');
  });

  var today = moment(),//.add(1, 'days'),
  calculateTo;
  $('input[name="calculate_from"]').pikaday(
    $.extend(pikadayOptions, {
      minDate: today.toDate(),
      defaultDate: today.toDate(),
      setDefaultDate: null,
      onSelect: function(date) {
        if ($("#resersearch-from")) {
          $("#resersearch-from").val(moment(date).format("YYYY-MM-DD"));
        }
        calculateTo = moment(date).add(2, 'days');
        var temp = moment(date).add(2, 'days');
        $('input[name="calculate_to"]')
          .pikaday('setMinDate', temp.toDate())
          .pikaday('setDate', calculateTo.toDate())
          .pikaday('gotoDate', calculateTo.toDate());
        if ($('input[name="calculate_to"]').val() != ''){
          $('.btn-calculate').removeAttr('disabled').css({'opacity': '1'});
        }
        if ($("#resersearch-to")) {
          $("#resersearch-to").val(calculateTo.format("YYYY-MM-DD"));
        }
      }
    })
  );

  var tomorrowCalculate = today.add(2, 'days');
  $('input[name="calculate_to"]').pikaday(
    $.extend(pikadayOptions, {
      minDate: tomorrowCalculate.toDate(),
      defaultDate: calculateTo ? calculateTo.toDate() : tomorrowCalculate.toDate(),
      setDefaultDate: calculateTo ? calculateTo.toDate() : null,
      onSelect: function(date) {
        calculateTo = moment(date);
        if ($('input[name="calculate_from"]').val() != ''){
          $('.btn-calculate').removeAttr('disabled').css({'opacity': '1'});
        }
        if ($("#resersearch-to")) {
          $("#resersearch-to").val(moment(date).format("YYYY-MM-DD"));
        }
      }
    })
  );

  $('.btn-calculate').on('click', function(e){
    e.preventDefault();
    var that = $(this),
    form = that.parents('form');
    $.ajax({
      url: form.attr('action'),
      type: form.attr('method'),
      data: form.serializeArray(),
    })
    .done(function(data) {
      if (data.success){
        $(".notes-small.pricing").css("display","block");
        form.find('.alert').remove();
        $('.result').append('<p class="alert result-calcul">' + price(data.price) + '</p>');
      }
      else{
        form.find('.alert').remove();
        $('.result').append('<p class="alert alert-error">' + data.message + '</p>');
      }
    })
    .fail(function(data) {
      form.find('.alert').remove();
      $('.result').append('<p class="alert alert-error">Error</p>');
    });
  });

  /*STEP BY STEP INFO*/
  var currentStep = 1;

  $(".next-step").click(function(){
     next()
     lookPrevNext();
  });

  $(".prev-step").click(function(){
    previous();
    lookPrevNext();
  });

  function lookPrevNext(){
    console.log('lookPrevNext', currentStep);

    /*
    ============================================
    CHOIX DE DATE
    */
    if(currentStep == 1){
      $(".steps-nav .next-step").css('display', 'inline-block');
      $(".steps-nav .prev-step").css('display', 'none');
      $(".steps-nav .next-step.demande-info").css("display", "none");

      $('form[name="modal-step-1"]').parsley().validate();
    }
    /*
    ============================================
    DISPONIBILITÉ OUI OU NON
    NON: CHOIX AUTRE DATE OU POURSUIVRE DEMANDE INFO
    OUI: RESERVEZ MAINTENANT OU POURSUIVRE DEMANDE INFO
    */
    else if(currentStep == 2){
      $(".steps-nav .next-step").css("display","none");
      $(".steps-nav .prev-step").css('display','inline-block');
      $(".steps-nav .next-step.demande-info").css("display","inline-block");

      if (dateMessageDatesSuccess) {
        $(".pre-reservez-maintenant").show();
      }

      $('.alerts .alert').remove();
      $(".reservez-maintenant").hide();
      $('#modal-search-bedrooms').hide();
      $('#modal-search-peoples').hide();
    }
    /*
    ============================================
    CHOIX DE DATE
    */
    else if(currentStep == 3){
      $( ".first-input" ).focus();
      $(".steps-nav .next-step").css("display","none");
      $(".steps-nav .prev-step").css('display','inline-block');
      $(".steps-nav .next-step.demande-info").css("display","none");
    }
  }

  function next(){
    console.log('next', currentStep);

    if ($('#start_date').val() != '' && $('#end_date').val() != ''){
      if(currentStep < 3){
        $(".steps[data-step='"+currentStep+"']").removeClass("active");

        currentStep++;

        setTimeout(function(){
          $(".steps[data-step='"+currentStep+"']").addClass("active");
        }, 500);
      }
    }
  }

  function previous(){
    if(currentStep > 1){
      $(".steps[data-step='"+currentStep+"']").removeClass("active");

      currentStep--;

      setTimeout(function(){
        $(".steps[data-step='"+currentStep+"']").addClass("active");
      }, 500);
    }
  }

  function openReservedPopUp(){
    var myHeight=($( window ).height()-$('.reservedPopup').height())/2;
    active=true;
    $('.reservedPopup').css("top",myHeight);
    openCover();
  }

  $("#reservedButton").on('click', function(){
    openReservedPopUp();
  });
  $("#closeReservation").click(function(){
    $('.reservedPopup').css("top","-1000px");
    active=false;
    closeCover();
  });

  $('.fa.tooltip-custom').click(function() {
    $(this).children('p.openable').toggle();
  });

  $('.fa.expend').click(function() {
    var icon = $(this);
    var target = icon.data('target');
    var div = $('.'+target);
    div.slideToggle(300);
    if (icon.hasClass('fa-arrow-circle-down')) {
      console.log('hasClass');
      icon.removeClass('fa-arrow-circle-down')
        .addClass('fa-arrow-circle-up');
    }
    else {
      console.log('else');
      icon.removeClass('fa-arrow-circle-up')
        .addClass('fa-arrow-circle-down');
    }
  });

  function openCover(){
    $('.coverScreen').css("display","block");
    setTimeout(function() {
      $('.coverScreen').css("opacity","1");
    }, 50);
  }
  function closeCover(){
    $('.coverScreen').css("opacity","0");
    setTimeout(function() {
      $('.coverScreen').css("display","none");
    }, 300);
  }




  $(window).resize(function() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if(active==true){
      myHeight=($( window ).height()-$('.reservedPopup').height())/2;
      if(iOS == false){
        $('.reservedPopup').css("top",myHeight);
      }
    }
  });


});
